// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"e1bd8704","85":"f638c2ed","165":"c1ef5811","413":"118c0a19","552":"caa9aedd","585":"19075749","646":"315c5b52","759":"f5489bfe","775":"66455fd0","794":"b276f089","907":"71249c11","948":"320a70e1"}[chunkId] + ".chunk.js";
};